import React from 'react';
import { useTranslation } from 'next-i18next';

import Title from '@/components/Title';

const Banner = () => {
  const { t } = useTranslation('aboutus');
  return (
    <div className="mb-20 h-[460px] bg-[url('/images/newAboutUs/banner-bg-phone.png')] bg-[auto_460px] bg-center bg-no-repeat pt-[121px] lg:mb-0 lg:h-[600px] lg:bg-[url('/images/newAboutUs/banner-bg.png')] lg:bg-[auto_600px] lg:pt-[162px] xl:h-[820px] xl:bg-[url('/images/newAboutUs/banner-bg-xl.png')] xl:bg-[auto_820px]">
      <Title theme="colorful">
        <strong>{t('banner-标题')}</strong>
      </Title>
    </div>
  );
};

export default Banner;
